// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3287) return "static/chunks/3287.bd51830dfa52ba65.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1971":"2ab68d5e88cc3072","2747":"e067b57bde9e5046","4902":"a2c1990e60a4dda3","5511":"ab55390c9beaa7ce","7103":"df6eec8f007f37cf","7963":"a814a932881232d3","8257":"abfe3d00d776f7b7"}[chunkId] + ".js";
};